import { Link } from "react-router-dom";
import { PageMeta } from "@/components/PageMeta";
import { GlassPanel } from "@/components/GlassPanel";
import { policies, POLICY_EFFECTIVE_DATE, POLICY_LAST_UPDATED } from "@/content/legalPolicies";
import { routeSeo } from "@/content/seo";
import { siteConfig } from "@/config/site";

export function LegalHubPage() {
  const seo = routeSeo["/legal"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/legal" />

      <section className="container page-hero">
        <p className="eyebrow">Legal</p>
        <h1 className="page-hero-title">Devory's policies</h1>
        <p className="page-hero-lede">
          All current Devory policies in one place. These are operational drafts prepared for
          Devory's first production website release and have not yet been reviewed by outside
          counsel. See each policy for its effective date.
        </p>
      </section>

      <section className="container section">
        <div className="grid-2">
          {policies.map((policy) => (
            <GlassPanel as="article" key={policy.slug} className="audience-card">
              <h2>
                <Link to={policy.path}>{policy.title}</Link>
              </h2>
              <p>{policy.summary}</p>
              <p className="policy-hub-date">
                Effective {POLICY_EFFECTIVE_DATE} · Last updated {POLICY_LAST_UPDATED}
              </p>
            </GlassPanel>
          ))}
        </div>
      </section>

      <section className="container section" aria-labelledby="company-information-heading">
        <GlassPanel as="article" className="audience-card">
          <h2 id="company-information-heading">Trading disclosure</h2>
          <p>
            Devory and {siteConfig.legalDeveloper} are product and trading identities. Devory is
            currently operated by:
          </p>
          <p>
            {siteConfig.legalEntity.name}, trading as {siteConfig.legalEntity.tradingAs}
            <br />
            {siteConfig.legalEntity.structure}, based in {siteConfig.legalEntity.jurisdiction}
            <br />
            Address for service: {siteConfig.legalEntity.serviceAddress}
          </p>
          <p>
            This disclosure is published to meet UK trading-name requirements for a sole trader
            operating under a name other than their own (Company, Limited Liability Partnership and
            Business (Names and Trading Disclosures) Regulations 2015). The address above is a
            service address for legal notices -- it is not Devory&rsquo;s support, billing, or product
            contact route; for any of those, use the <Link to="/contact">contact form</Link> or{" "}
            <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a>.
          </p>
        </GlassPanel>
      </section>
    </>
  );
}
